import type { CityOption } from "@/lib/places";

/**
 * Отбор по городу КНОПКАМИ, а не выпадающим списком (задача владельца
 * 09.09.26).
 *
 * Разница не косметическая: у списка сначала спрашивают, ЕСТЬ ли города, и
 * только потом видят, где вещь лежит. Кнопки отвечают на оба вопроса сразу —
 * «Самара 6, Ростов 5, Воронеж 1» читается одним взглядом и одним нажатием
 * сужается. Города при этом идут по убыванию, то есть первым стоит тот, куда
 * ехать за вещью.
 *
 * Число на кнопке — то, чем меряется САМ СПИСОК: у «где лежит» это вещи, у
 * «где лежал» — места. Считает его страница и передаёт готовым: компонент не
 * должен знать, про какой из двух списков он сейчас.
 */
export function CityButtons({
  options,
  value,
  onChange,
  count,
  total,
  totalLabel,
  hint,
}: {
  options: readonly CityOption[];
  /** Выбранный город; пустая строка — все. */
  value: string;
  onChange: (value: string) => void;
  /** Число на кнопке города. */
  count: (city: CityOption) => number;
  /** Число на кнопке «все города». */
  total: number;
  totalLabel: string;
  /** Подсказка кнопки: «Ростов: 5 шт в 5 местах». */
  hint: (city: CityOption) => string;
}) {
  // Один город — отбирать не из чего: кнопка «все» и кнопка «Ростов» показали
  // бы одно и то же, а два одинаковых ответа читаются как разные.
  if (options.length < 2) return null;

  const btn =
    "h-7 rounded-[var(--radius-ui)] border px-2.5 text-[12.5px] font-normal transition-colors ";
  const off = "border-border text-fg-muted hover:bg-bg-hover hover:text-fg";
  const on = "border-fg bg-fg text-bg";

  return (
    <span data-annot="города" className="flex flex-wrap items-center gap-1.5">
      <button
        type="button"
        data-annot="все города"
        aria-pressed={value === ""}
        onClick={() => onChange("")}
        className={btn + (value === "" ? on : off)}
      >
        {totalLabel} <span className="tnum">{total}</span>
      </button>
      {options.map((city) => (
        <button
          key={city.value}
          type="button"
          data-annot={city.label}
          aria-pressed={value === city.value}
          title={hint(city)}
          // Повторное нажатие СНИМАЕТ отбор: кнопка, которая только ставит,
          // заставляет искать «все города» глазами в другом конце ряда.
          onClick={() => onChange(value === city.value ? "" : city.value)}
          className={btn + (value === city.value ? on : off)}
        >
          {city.label} <span className="tnum">{count(city)}</span>
        </button>
      ))}
    </span>
  );
}
